import { FormHelperText as MuiFormHelperText, FormHelperTextProps } from '@mui/material';
import { AlertCircleInvert } from '@portals/icons';
import React from 'react';

import { Typography } from '../Typography/Typography';

export const FormHelperText: React.FC<FormHelperTextProps> = ({ error, children, ...props }) => {
  return (
    <MuiFormHelperText error={error} {...props}>
      {error && <AlertCircleInvert />}
      <Typography variant="h6" component="div" color={error ? 'error.main' : 'grey.main'}>
        {children}
      </Typography>
    </MuiFormHelperText>
  );
};
